import SC from "./style";
import TimezoneConverter from "components/TimeZoneConvertor";
import InnoIcons from "@InnoIcons/";
import theme from "@theme/";
import { useState } from "react";
import FileCard from "./FileCard";
import EmailDetailsTooltip from "components/EmailDetailsTooltip";

const EmailContent = (props) => {
  const { data } = props;
  const [toggle, setToggle] = useState(false);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <p
          style={{
            opacity: "0.7",
            fontWeight: "bold",
            fontSize: "12px",
            marginRight: "5px",
          }}
        >
          Posted By
        </p>
        <EmailDetailsTooltip
          data={[data?.userData]}
          maxWidth={"500px"}
          fontSize={"13px"}
          color={theme.colors.themeColor}
          fontWeight="bold"
        />
        <p style={{ margin: "0px 5px 0px 5px" }}>on</p>{" "}
        <TimezoneConverter time={data?.createdOn} />
      </div>
      <p
        style={{
          display: "flex",
          textAlign: "center",
          alignItems: "center",
          gap: "2px",
          cursor: "pointer",
          transition: "0.5s ease-in-out",
          fontWeight: "bold",
          fontSize: "13px",
        }}
      >
        <InnoIcons.EmailIcon
          sx={{ color: theme.colors.themeColor, fontSize: "18px" }}
        />
        Details
        {toggle ? (
          <InnoIcons.ArrowDropUpIcon
            sx={{ fontSize: "25px" }}
            onClick={handleToggle}
          />
        ) : (
          <InnoIcons.ArrowDropDownIcon
            sx={{ fontSize: "25px" }}
            onClick={handleToggle}
          />
        )}
      </p>

      {toggle && (
        <div style={{ backgroundColor: "#FFFBFA", padding: "2px" }}>
          <SC.LabelContainer>
            <SC.Label>TO</SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <EmailDetailsTooltip
                  data={data?.sendToWithName}
                  maxWidth={"500px"}
                  fontSize={"12px"}
                  opacity={"0.6"}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
          <SC.LabelContainer>
            <SC.Label>CC</SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <EmailDetailsTooltip
                  data={data?.sendCcWithName}
                  maxWidth={"500px"}
                  fontSize={"12px"}
                  opacity={"0.6"}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
          <SC.LabelContainer>
            <SC.Label>BCC</SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <EmailDetailsTooltip
                  data={data?.sendBccWithName}
                  maxWidt={"500px"}
                  fontSize={"12px"}
                  opacity={"0.6"}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
        </div>
      )}

      <div
        style={{
          display: "flex",
          gap: "10px",
          backgroundColor: "#FCFCFC",
          marginBottom: "10px",
          borderBottom: `1px solid ${theme.colors.bordertask}`,
          flexWrap: "wrap",
        }}
      >
        <FileCard data={data} />
      </div>

      <SC.CardContainerStyle>
        <div style={{ padding: "0px 10px " }}>
          <p style={{ fontWeight: "bold" }}>Content:</p>
          <SC.MessageContent
            dangerouslySetInnerHTML={{ __html: data?.message }}
          />
        </div>
      </SC.CardContainerStyle>
    </>
  );
};

export default EmailContent;
